import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare2.welcome';
export const Component = loadable(
  () => import('./containers/WelcomeTwoContainer')
);
export { default as propsFormatter } from './propsFormatter';
